import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm, formValueSelector} from "redux-form/immutable";
import {submit} from "redux-form";
import ActionButton from "../../ActionButton";
import FormFieldsTable from "../../forms/FormFieldsTable";
import TextInputField from "../../forms/TextInputField";
import DropDownInputField from "../../forms/DropDownInputField";
import {Map} from "immutable";
import {validatePresence, validateIncludes} from "../../../lib/Validators";
import {cancelChangeWarehouseAddress, changeWarehouseAddress} from "../../../actions/InventoryApiActions";
import {getSubmitInfoForCommand, getWarehouseWithId} from "../../../reducers/inventoryReducer";
import {isSubmitting, submitLabel} from "../../../lib/CommandStatus";
import {getCountries, getUSStates, isUS} from "../../../lib/CountriesAndStates";

function validateForm(values, props) {
  let errors = Map();
  errors = validatePresence(errors, values, "country_code");
  errors = validatePresence(errors, values, "address_line1");
  errors = validatePresence(errors, values, "city");
  if (isUS(values.get("country_code"))) {
    let usStates = getUSStates().map(x => x.get("code"));
    errors = validateIncludes(errors, values, "state_province", usStates)
  }
  errors = validatePresence(errors, values, "postcode");
  return errors.toJS();
}

function toUpperCase(val) {
  return val && val.toUpperCase();
}

class WarehouseAddressForm extends Component {

  render() {
    let {handleSubmit, submit, submitInfo} = this.props;

    let stateProvinceInput = <Field
                              label="State / Province"
                              name="state_province"
                              component={TextInputField}
                              />
    if (isUS(this.props.countryValue)) {
      stateProvinceInput = <Field
        label="State / Province"
        name="state_province"
        component={DropDownInputField}
        data={getUSStates()}
        valueKey="code"  
        titleKey="name" 
        />
      }

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Country"
              name="country_code"
              component={DropDownInputField}
              data={getCountries()}
              valueKey="code"  
              titleKey="name" 
              />
            <Field
              label="Address Line 1"
              name="address_line1"
              component={TextInputField}
              />
            <Field
              label="Address Line 2"
              name="address_line2"
              component={TextInputField}
              />
            <Field
              label="City"
              name="city"
              component={TextInputField}
              />

              {stateProvinceInput}

            <Field
              label="Postal Code"
              name="postcode"
              normalize={toUpperCase}
              component={TextInputField}
              />      
          </FormFieldsTable>
        </div>
        <div className="buttons">
          <ActionButton label={submitLabel(submitInfo, "Submit")} onClick={submit} active={!isSubmitting(submitInfo)} />
          <ActionButton label="Cancel" active={!isSubmitting(submitInfo)} onClick={this.props.cancelChangeWarehouseAddress} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "WarehouseAddressForm",
  validate: validateForm
})(WarehouseAddressForm);

const selector = formValueSelector('WarehouseAddressForm')
const ConnectedForm = connect(
  (state, ownProps) => {
    const warehouse = getWarehouseWithId(state.get("inventory"), ownProps.id);
    return {
      submitInfo: getSubmitInfoForCommand(state.get("inventory"), "ChangeWarehouseAddress"),
      countryValue: selector(state, "country_code"),
      initialValues: {
        id: ownProps.id,
        country_code: warehouse.getIn(["address", "country_code"], ""),
        address_line1: warehouse.getIn(["address", "address_line1"], ""),
        address_line2: warehouse.getIn(["address", "address_line2"], ""),
        city: warehouse.getIn(["address", "city"], ""),
        state_province: warehouse.getIn(["address", "state_province"], ""),
        postcode: warehouse.getIn(["address", "postcode"], "")
      }
    }
  },
  {
    cancelChangeWarehouseAddress,
    submit,
    onSubmit: (data) => changeWarehouseAddress(data)
  }
)(ReduxForm);

export default ConnectedForm;